"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBack = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _localization = require("@lt/localization");
var _hasCashbackSuperType = require("./utils/hasCashbackSuperType");
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _MobilePopupBottom = _interopRequireDefault(require("../MobilePopupBottom"));
var _CashBackDefault = require("./CashBackDefault");
var _styles = require("./styles");
var _currency = require("../../utils/currency");
var _excluded = ["type", "className", "withoutPopup", "isMobile", "popup", "customCashbackTooltipText", "currencyCode", "isHomepage"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CashBack = exports.CashBack = function CashBack(_ref) {
  var type = _ref.type,
    className = _ref.className,
    withoutPopup = _ref.withoutPopup,
    isMobile = _ref.isMobile,
    popup = _ref.popup,
    customCashbackTooltipText = _ref.customCashbackTooltipText,
    currencyCode = _ref.currencyCode,
    isHomepage = _ref.isHomepage,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var togglePopup = function togglePopup() {
    return setShowPopup(function (on) {
      return !on;
    });
  };
  var isSuper = (0, _hasCashbackSuperType.hasCashbackSuperType)(type);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var tooltipText = t(isSuper ? 'cashback.super.tooltip' : 'cashback.basic.tooltip', {
    context: (0, _currency.currencyLow)(currencyCode)
  });
  var label = t(isSuper ? 'cashback.super.label' : 'cashback.basic.label');
  if (withoutPopup) {
    return /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, null, /*#__PURE__*/_react["default"].createElement(_CashBackDefault.CashBackDefault, (0, _extends2["default"])({}, rest, {
      className: className,
      label: label,
      isHomepage: isHomepage
    })));
  }
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, {
    onClick: togglePopup,
    onKeyDown: togglePopup,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_CashBackDefault.CashBackDefault, (0, _extends2["default"])({}, rest, {
    label: label,
    isSuper: isSuper
  }))), /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], (0, _extends2["default"])({
    visible: showPopup,
    onClick: togglePopup
  }, popup), customCashbackTooltipText || /*#__PURE__*/_react["default"].createElement("span", null, tooltipText))) : /*#__PURE__*/_react["default"].createElement(_Bubble["default"], (0, _extends2["default"])({
    text: customCashbackTooltipText || tooltipText,
    width: 265,
    className: className
  }, popup), /*#__PURE__*/_react["default"].createElement(_CashBackDefault.CashBackDefault, (0, _extends2["default"])({}, rest, {
    label: label,
    isSuper: isSuper
  })));
};